import React, { useContext, useState } from "react";
import "./search.css";
import { Box } from "@mui/material";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import Header from "../../../COMPONENTS/header/Header";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import AuthContext from "../../../CONTEXT/AuthProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

function Search() {
  const { auth } = useContext(AuthContext);
  const accessToken = auth.accessToken;
  const [phoneNumberIdentifier, setPhoneNumberIdentifier] = useState("255");
  const [name, setName] = useState();
  const [operator, setOperator] = useState();
  const [show, setShow] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (phoneNumberIdentifier.length === 12) {
      try {
        const userData = {
          phoneNumberIdentifiers: [phoneNumberIdentifier],
          username: auth.username,
          subscriberName: auth.subscriberName,
        };

        const response = await axios.post("/api/name-lookup", userData, {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        });
        setName(response.data[0].name);
        setOperator(response.data[0].operator);
        setShow(true);
      } catch (err) {
        console.log(err);
      }
    } else {
      toast.error("Incorrect phone number length!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleClose = () => setShow(false);

  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="10px">
          <Box m="10px">
            <Header title="NEW SEARCH" subtitle="Verify user's phone number" />
            <>
              <Form onSubmit={handleFormSubmit}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={phoneNumberIdentifier}
                    onChange={(e) => setPhoneNumberIdentifier(e.target.value)}
                    maxLength={12}
                    required
                  />
                  <Form.Text className="text-muted">(255763490876)</Form.Text>
                </Form.Group>
                <Button variant="danger" type="submit">
                  submit
                </Button>
                <ToastContainer />
              </Form>

              <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Phone Number Verification</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p style={{ fontSize: "18px" }}>
                    Name: <b>{name}</b>
                  </p>
                  <p style={{ fontSize: "18px" }}>
                    Operator: <b>{operator}</b>
                  </p>
                  <p style={{ fontSize: "18px" }}>
                    Phone number: <b>{phoneNumberIdentifier}</b>
                  </p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </>
          </Box>
        </Box>
      </main>
    </div>
  );
}

export default Search;
